
import { Sale } from "@/models/base";
import AppSignSaleModalBase from "@/components/sales/SignSaleModalBase.vue";

import Vue from "vue";
import { SaleService } from "@/services/sale-service";

export default Vue.extend({
	data() {
		return {

		};
	},
	props: {
		sale: {
			type: Object as () => Sale,
			required: true
		},
	},
	computed: {

	},
	methods: {
		close() {
			this.$emit("close");
		},
		async doConfirm(signedBy:string,blob:Blob) {
			let s = await SaleService.signSale(this.sale,signedBy,blob);
			this.$emit("signed",s);
			this.close();
		}
	},
	created(){

	},
	components: {
		AppSignSaleModalBase
	},
	i18nEx: {
		componentPrefix: "components.client-portal"
	}
});
